/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DepositoMovimientosChequeModeloMLS { 
    codigo?: string;
    bancoEmisor?: string;
    cuenta?: string;
    estado?: string;
    usuario?: string;
    fechaIngreso?: string;
    fechaMaquinaIngreso?: string;
    fechaEfectivizacion?: string;
    transaccion?: string;
    valor?: number;
    esCertificado?: boolean;
}